   document.addEventListener("DOMContentLoaded", function() {
        
        // Define validation patterns for each field type
        const patterns = {
            company: {
                regex: /^[A-Za-z\s&.\-]*$/,
                errorMsg: "Company name: Only letters, spaces, &, -, . allowed",
                minLength: 2
            },
            firstName: {
                regex: /^[A-Za-z\s]*$/,
                errorMsg: "First Name: Only letters and spaces allowed",
                minLength: 2
            },
            lastName: {
                regex: /^[A-Za-z]*$/,
                errorMsg: "Last Name: Only letters allowed",
                minLength: 2
            },
            email: {
                regex: /^[A-Za-z0-9@._\-]*$/,
                errorMsg: "Email: Invalid character",
                validation: 'email'
            },
            mobile: {
                regex: /^[0-9]*$/,
                errorMsg: "Mobile: Only numbers allowed",
                maxLength: 10
            },
            description: {
                regex: /^[A-Za-z0-9\s.,!?\-&'()]*$/,
                errorMsg: "Invalid character in description"
            }
        };

        // Get all input fields
        const companyField = document.getElementById('Company');
        const firstNameField = document.getElementById('First_Name');
        const lastNameField = document.getElementById('Last_Name');
        const emailField = document.getElementById('Email');
        const mobileField = document.getElementById('Mobile');
        const descriptionField = document.getElementById('Description');
         let isValid = false;
        //  console.log("isValid off submit:",isValid);

        // Map fields with their validation types
        const fieldMap = {
            'Company': { field: companyField, type: 'company' },
            'First_Name': { field: firstNameField, type: 'firstName' },
            'Last_Name': { field: lastNameField, type: 'lastName' },
            'Email': { field: emailField, type: 'email' },
            'Mobile': { field: mobileField, type: 'mobile' },
            'Description': { field: descriptionField, type: 'description' }
        };

        // Function to update field border color
        function updateFieldBorder(field, isValid) {
            field.style.backgroundColor = '#fff';
            if (field.value.trim() === '') {
                field.style.borderColor = '#c0c6cc';
                field.style.boxShadow = 'none';
            } else if (isValid) {
                field.style.borderColor = '#52DEAB';
                field.style.boxShadow = '0 0 0 2px rgba(82, 222, 171, 0.2)';
            } else {
                field.style.borderColor = '#ff4444';
                field.style.boxShadow = '0 0 0 2px rgba(255, 68, 68, 0.2)';
            }
        }

        // Add real-time input validation
        Object.values(fieldMap).forEach(({ field, type }) => {
            if (!field) return;

            field.addEventListener('input', function(e) {
                let value = this.value;
                const pattern = patterns[type];

                // Prevent invalid characters
                if (!pattern.regex.test(value)) {
                    this.value = value.slice(0, -1);
                    updateFieldBorder(this, false);
                    return;
                }

                // Max length check for mobile
                if (type === 'mobile' && value.length > 10) {
                    this.value = value.slice(0, 10);
                    updateFieldBorder(this, true);
                    return;
                }

                // Update border based on validation
                if (value.trim() !== '') {
                    let isValid = validateFieldValue(this, type);
                    updateFieldBorder(this, isValid);
                } else {
                    updateFieldBorder(this, true);
                }
            });

            // Add blur validation
            field.addEventListener('blur', function() {
                validateFieldOnBlur(this, type);
            });

            // Remove border on focus
            field.addEventListener('focus', function() {
                this.style.borderColor = '#c0c6cc';
            });
        });

        // Validate field value
        function validateFieldValue(field, type) {
            const pattern = patterns[type];
            const value = field.value.trim();

            if (!value) {
                return true;
            }

            // Email validation
            if (type === 'email' && value) {
                if (!isValidEmail(value)) {
                    return false;
                }
            }

            // Mobile length check
            if (type === 'mobile' && value.length !== 10) {
                return false;
            }

            // Min length check
            if (pattern.minLength && value.length < pattern.minLength) {
                return false;
            }

            return true;
        }

        // Validate field on blur
        function validateFieldOnBlur(field, type) {
            const pattern = patterns[type];
            const value = field.value.trim();

            if (!value && field.hasAttribute('required')) {
                field.style.borderColor = '#ff4444';
                return;
            }

            if (value) {
                // Email validation
                if (type === 'email' && value) {
                    if (!isValidEmail(value)) {
                        field.style.borderColor = '#ff4444';
                        return;
                    }
                }

                // Mobile length check
                if (type === 'mobile' && value.length !== 10) {
                    field.style.borderColor = '#ff4444';
                    return;
                }

                // Min length check
                if (pattern.minLength && value.length < pattern.minLength) {
                    field.style.borderColor = '#ff4444';
                    return;
                }
            }

            // If valid, show green border
            if (value) {
                field.style.borderColor = '#52DEAB';
            } else {
                field.style.borderColor = '#0000';
            }
        }

        // Validate email format
        function isValidEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        }

        // Get the form
        const form = document.getElementById('webform1136191000000425052');

        // Override form submission
        form.addEventListener('submit', function(e) {
            e.preventDefault();

            const requiredFields = [
                { field: companyField, type: 'company', name: 'Company' },
                { field: firstNameField, type: 'firstName', name: 'First Name' },
                { field: lastNameField, type: 'lastName', name: 'Last Name' },
                { field: emailField, type: 'email', name: 'Email' },
                { field: mobileField, type: 'mobile', name: 'Mobile' }
            ];
            let isValid = true;


           

            // Validate all required fields
            requiredFields.forEach(({ field, type, name }) => {
                if (!field) return;

                const value = field.value.trim();

                // Check if empty
                if (!value) {
                    field.style.borderColor = '#ff4444';
                    
                    isValid = false;
                    return;
                }

                // Validate email
                if (type === 'email' && !isValidEmail(value)) {
                    field.style.borderColor = '#ff4444';
                    
                    isValid = false;
                    return;
                }

                // Validate mobile (10 digits)
                if (type === 'mobile' && value.length !== 10) {
                    field.style.borderColor = '#ff4444';
                    
                    isValid = false;
                    return;
                }

                // Validate min length
                const pattern = patterns[type];
                if (pattern.minLength && value.length < pattern.minLength) {
                    field.style.borderColor = '#ff4444';
                    
                    isValid = false;
                    return;
                }

                // Show green border if valid
                field.style.borderColor = '#52DEAB';
            });
            // isValid = true;


            console.log("isValid on submit:",isValid);
             if (isValid) {
                alert('Form submitted successfully!');
                
                // Reset form and all field borders
                form.reset();
               
            }
        });
       
    });